import React from 'react';
import '../../styles/money.css';
import { choose } from '../../utils/platform';
import { useMyWork } from './useMyWork';
import MyWorkDesktop from './MyWork.desktop';
import MyWorkMobile from './MyWork.mobile';

const MyWorkView = choose(MyWorkDesktop, MyWorkMobile);

// /app/my-work — every user sees the services assigned to them (vendors); no
// event selection needed, so a caterer can sign in and immediately see his jobs.
export default function MyWork() {
  const vm = useMyWork();
  return <MyWorkView vm={vm} />;
}
